var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"ma-2",staticStyle:{"background-color":"#f6f7f9","border-top":"4px solid #001529"},attrs:{"min-height":"100","max-width":"400"},on:{"click":_vm.select}},[_c('v-card-title',[_vm._v(_vm._s(_vm.result.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }